import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import UnkownIcon from '@material-ui/icons/HelpOutline';
import FailedIcon from '@material-ui/icons/ErrorOutline';
import AbortedIcon from '@material-ui/icons/CancelPresentation';
import CompletedIcon from '@material-ui/icons/CheckCircleOutline';
import TimeoutIcon from '@material-ui/icons/Update';
import RunningIcon from '@material-ui/icons/Settings';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  BATCH_STATUS_UNKOWN,
  BATCH_STATUS_CREATED,
  BATCH_STATUS_SUBMITTED,
  BATCH_STATUS_ABORTED,
  BATCH_STATUS_FAILED,
  BATCH_STATUS_COMPLETED,
} from '../../services/BatchService';
import './BatchStatus.scss';

const Tooltips = [];
Tooltips[BATCH_STATUS_UNKOWN] = 'UNKOWN';
Tooltips[BATCH_STATUS_CREATED] = 'CREATED';
Tooltips[BATCH_STATUS_SUBMITTED] = 'SUBMITTED';
Tooltips[BATCH_STATUS_ABORTED] = 'ABORTED';
Tooltips[BATCH_STATUS_FAILED] = 'FAILED';
Tooltips[BATCH_STATUS_COMPLETED] = 'COMPLETED';

const StatusClassnames = [];
StatusClassnames[BATCH_STATUS_UNKOWN] = 'status-unknown';
StatusClassnames[BATCH_STATUS_CREATED] = 'status-created';
StatusClassnames[BATCH_STATUS_SUBMITTED] = 'status-submitted';
StatusClassnames[BATCH_STATUS_ABORTED] = 'status-aborted';
StatusClassnames[BATCH_STATUS_FAILED] = 'status-failed';
StatusClassnames[BATCH_STATUS_COMPLETED] = 'status-completed';

const BatchStatus = ({ value, object: batch }) => {
  // value = LEAVING; // eslint-disable-line
  let Icon;
  const { errorMsg } = batch;
  switch (value) {
    case BATCH_STATUS_UNKOWN:
      Icon = <UnkownIcon />;
      break;
    case BATCH_STATUS_CREATED:
      Icon = <CircularProgress size={22} />;
      break;
    case BATCH_STATUS_SUBMITTED:
      Icon = <RunningIcon className="grb-rotate" />;
      break;
    case BATCH_STATUS_ABORTED:
      Icon = <AbortedIcon />;
      break;
    case BATCH_STATUS_FAILED:
      Icon = <FailedIcon />;
      break;
    case BATCH_STATUS_COMPLETED:
      Icon = <CompletedIcon />;
      break;
    default:
      Icon = <TimeoutIcon />;
      break;
  }
  return (
    <Tooltip
      title={!errorMsg ? (
        Tooltips[value]
      ) : (
        <React.Fragment>
          {Tooltips[value]}<br />
          {errorMsg}
        </React.Fragment>
      )}
    >
      <div className={`grb-batch-status ${StatusClassnames[value]}`}>
        {Icon}
      </div>
    </Tooltip>
  );
};

BatchStatus.propTypes = {
  value: PropTypes.number,
  object: PropTypes.shape({}),
  jobService: PropTypes.shape({}).isRequired,
};

BatchStatus.defaultProps = {
  value: 0,
  object: undefined,
};

export default BatchStatus;
